package com.dignicate.web.viewmodels

import com.dignicate.web.domain.DocumentContent
import com.dignicate.web.domain.GetTermsUseCase
import com.dignicate.web.domain.Resource
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed interface TermsUiState {
    object Loading : TermsUiState
    data class Ready(val content: DocumentContent) : TermsUiState
    data class Error(val message: String) : TermsUiState
}

class TermsViewModel(
    private val getTermsUseCase: GetTermsUseCase
) : ViewModel() {

    private val _uiState = MutableStateFlow<TermsUiState>(TermsUiState.Loading)
    val uiState: StateFlow<TermsUiState> = _uiState.asStateFlow()

    init {
        viewModelScope.launch {
            getTermsUseCase.data.collect { resource ->
                _uiState.value = when (resource) {
                    is Resource.Initialized -> TermsUiState.Loading
                    is Resource.InProgress -> TermsUiState.Loading
                    is Resource.Success<DocumentContent> -> TermsUiState.Ready(resource.data)
                    is Resource.Failure -> TermsUiState.Error(resource.error.message)
                }
            }
        }
    }

    override fun onCreated() {
        super.onCreated()
        viewModelScope.launch {
            getTermsUseCase.fetch()
        }
    }
}
